import { Link } from "react-router-dom";
import Logo from "../../assets/images/hangsushi-logo.webp";
// import { PrimaryButton } from "../Buttons";
export function Footer() {
  // function handleOrderButton() {
  //   window.location.href = "https://tista-sushi.orderintelligence.no/";
  // }
  return (
    <footer className="text-center text-white">
      <div className="flex justify-center">
        <Link to="/" className="self-center">
          <img
            src={Logo}
            alt="logo of hangs sushi in moelv ringsaker norway asian restaurant thai vietnamese cuisine"
            className="w-36 md:w-56"
          />
        </Link>
      </div>

      <div>
        <div className="flex items-center p-2 justify-center">
          {/* Phone Icon */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1.5em"
            height="1.5em"
            viewBox="0 0 24 24"
            fill="#F22727"
          >
            <path d="M6.6,10.2C7.9,12.7,9.9,14.8,12.4,16.1l1.9-1.9c0.2-0.2,0.5-0.2,0.7-0.1c1,0.3,2.1,0.5,3.2,0.5c0.4,0,0.8,0.3,0.8,0.8v3.3c0,0.4-0.3,0.8-0.8,0.8C12.2,20,4,11.8,4,2.8C4,2.3,4.4,2,4.8,2h3.3c0.4,0,0.8,0.3,0.8,0.8c0,1.1,0.2,2.1,0.5,3.2c0,0.3,0,0.6-0.1,0.7L6.6,10.2z" />
          </svg>

          {/* Phone Number Link */}
          <a className="hover:underline ml-2" href="tel:+4790894684">
            +47 908 94 684
          </a>
        </div>

        <div className="flex items-center p-2 justify-center">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="1em"
            height="1em"
            viewBox="0 0 512 512"
          >
            <path
              fill="#F22727"
              d="M240.3 396.8c3.3 5.1 9.1 8.5 15.7 8.5s12.4-3.4 15.8-8.5L382 226.6c14.8-22.9 23.4-48.1 23.4-77.3C405.3 64.9 339 0 256 0S106.7 64.9 106.7 149.3c0 29.2 8.6 54.4 23.4 77.3zM256 64c47.1 0 85.3 38.2 85.3 85.3s-38.2 85.3-85.3 85.3s-85.3-38.2-85.3-85.3S208.9 64 256 64m109.4 259.5L256 469.3L146.6 323.5c-37.4 19.6-61.3 48.9-61.3 81.8C85.3 464.2 161.7 512 256 512s170.7-47.8 170.7-106.7c0-32.9-23.9-62.2-61.3-81.8"
            />
          </svg>
          <a
            href="https://www.google.com/maps/place/Hangs+Sushi+House/@60.8649215,10.5935651,60667m/data=!3m1!1e3!4m6!3m5!1s0x466a791aae782419:0x84416a87c611788b!8m2!3d60.9299856!4d10.702322!16s%2Fg%2F11h_wq50mn?entry=ttu&g_ep=EgoyMDI1MDIxMi4wIKXMDSoASAFQAw%3D%3D"
            target="_blank"
            rel="noopener noreferrer"
            className="ml-2 hover:underline"
          >
            Åsmarkvegen 6, 2390 Moelv
          </a>{" "}
        </div>
      </div>
      <p className="my-5">
        &copy; {new Date().getFullYear()} Powered by{" "}
        <a
          class="email"
          href="https://tech-intelligence.no"
          className="text-orange hover:underline"
        >
          Tech Intelligence
        </a>
      </p>
    </footer>
  );
}
